// Import Features
import produce from "immer";
import { ImportData } from "../actions";
import { getCurrentTimeInMs } from "../../utils/";
// Types
import type { Action } from "deox";
import type {
  ImportDataCollection,
  StateImportData as State,
  TypeImportData,
} from "../../types/importData.types";
type ImportDataActionReducers = Action<
  string,
  {
    importData:
      | State["imports"][ImportDataCollection]["data"]
      | { [k: string]: any };
    importDataType: ImportDataCollection;
    hasErrors: State["importDataNotification"]["hasErrors"];
    typeImport: TypeImportData;
  }
>;
// Import Data: (Users or rotations)
const initialStateImport = {
  data: [],
  lastFetching: 0,
  status: "idle" as const,
};
const initialState: State = {
  imports: {
    users: { ...initialStateImport },
    rotations: { ...initialStateImport },
    tenantSettings: { ...initialStateImport },
  },
  importDataNotification: {
    toShow: false,
    hasErrors: false,
    typeImport: "",
  },
};
const importData: (state: State, action: ImportDataActionReducers) => State =
  produce((draft: State, action: ImportDataActionReducers) => {
    switch (action.type) {
      case ImportData.IMPORT_DATA_FETCH_REQUEST:
        draft.imports[action.payload.importDataType].status = "fetching";
        break;
      case ImportData.IMPORT_DATA_FETCH_SUCCESS:
        draft.imports[action.payload.importDataType].data = action.payload
          .importData as State["imports"][ImportDataCollection]["data"];
        draft.imports[action.payload.importDataType].lastFetching =
          getCurrentTimeInMs();
        draft.imports[action.payload.importDataType].status = "ready";
        break;
      case ImportData.IMPORT_DATA_FETCH_FAILURE:
        draft.imports[action.payload.importDataType].status = "failed";
        break;
      case ImportData.IMPORT_DATA_SEND_SUCCESS:
        if (action.payload.importData && action.payload.importDataType) {
          const collection = draft.imports[action.payload.importDataType];
          const importAccepted = action.payload.importData as {
            _id?: string;
            [k: string]: any;
          };
          const existingIndex = collection.data.findIndex(
            ({ _id }) => _id && _id === importAccepted._id
          );
          if (existingIndex >= 0) {
            collection.data[existingIndex] = importAccepted;
          } else {
            collection.data.unshift(importAccepted);
          }
          collection.lastFetching = getCurrentTimeInMs();
        }
        break;
      case ImportData.IMPORT_DATA_SHOW_NOTIFICATION:
        draft.importDataNotification.toShow = true;
        draft.importDataNotification.hasErrors = action.payload.hasErrors;
        draft.importDataNotification.typeImport = action.payload.typeImport;
        draft.imports.users.lastFetching = 0;
        draft.imports.rotations.lastFetching = 0;
        draft.imports.tenantSettings.lastFetching = 0;
        break;
      case ImportData.IMPORT_DATA_HIDE_NOTIFICATION:
        draft.importDataNotification.toShow = false;
        draft.importDataNotification.hasErrors = false;
        draft.importDataNotification.typeImport = "";
    }
  }, initialState);
export default importData;
